var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-excel-mapper", {
    attrs: {
      service: _vm.PriceListProductService.excelMapperService,
      "allowed-output-headers": _vm.cols,
    },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
      file: _vm.onExcelMapperFile,
    },
    scopedSlots: _vm._u([
      {
        key: "extra-settings",
        fn: function (slotProps) {
          return [
            _c(
              "w-row",
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12" } },
                  [
                    _c("app-product-matching-method-select", {
                      model: {
                        value:
                          slotProps.settings.Settings.ExtraData
                            .ProductMatchingMethod,
                        callback: function ($$v) {
                          _vm.$set(
                            slotProps.settings.Settings.ExtraData,
                            "ProductMatchingMethod",
                            $$v
                          )
                        },
                        expression:
                          "slotProps.settings.Settings.ExtraData.ProductMatchingMethod",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "w-col",
                  { attrs: { xs: "12" } },
                  [
                    _c("app-contact-search", {
                      attrs: {
                        "group-id": 2,
                        label: _vm.$ct("supplier"),
                        fancy: "",
                        "icon-left": "times",
                      },
                      on: {
                        "icon-left-click": function ($event) {
                          return _vm.setSupplierEmpty(
                            slotProps.settings.Settings
                          )
                        },
                      },
                      model: {
                        value: slotProps.settings.Settings.ExtraData.SupplierID,
                        callback: function ($$v) {
                          _vm.$set(
                            slotProps.settings.Settings.ExtraData,
                            "SupplierID",
                            $$v
                          )
                        },
                        expression:
                          "slotProps.settings.Settings.ExtraData.SupplierID",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }